(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fragrance-collections"] && !Shopify.designMode) return;
  try {
    

document
  .querySelectorAll('.fragrance-collections')
  .forEach(function (root) {

    var track =
      root.querySelector('[data-fc-track]');

    var slides =
      Array.from(
        root.querySelectorAll('[data-fc-slide]')
      );

    var dots =
      Array.from(
        root.querySelectorAll('[data-fc-dot]')
      );


    if (
      !track ||
      !slides.length ||
      !dots.length
    ) {
      return;
    }


    function isSliderMode() {

      return (
        window.innerWidth <= 749 &&
        root.classList.contains(
          'fragrance-collections--mobile-slider'
        )
      );

    }


    function setActive(index) {

      dots.forEach(
        function (dot, dotIndex) {

          var active =
            dotIndex === index;

          dot.classList.toggle(
            'is-active',
            active
          );


          if (active) {

            dot.setAttribute(
              'aria-current',
              'true'
            );

          } else {

            dot.removeAttribute(
              'aria-current'
            );

          }

        }
      );

    }


    dots.forEach(
      function (dot, index) {

        dot.addEventListener(
          'click',
          function () {

            if (!isSliderMode()) {
              return;
            }


            slides[index].scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start'
            });

          }
        );

      }
    );


    var ticking = false;


    track.addEventListener(
      'scroll',
      function () {

        if (
          ticking ||
          !isSliderMode()
        ) {
          return;
        }


        ticking = true;


        window.requestAnimationFrame(
          function () {

            var trackRect =
              track.getBoundingClientRect();

            var closestIndex = 0;
            var closestDistance = Infinity;


            slides.forEach(
              function (slide, index) {

                var slideRect =
                  slide.getBoundingClientRect();

                var distance =
                  Math.abs(
                    slideRect.left -
                    trackRect.left
                  );


                if (
                  distance <
                  closestDistance
                ) {

                  closestDistance =
                    distance;

                  closestIndex =
                    index;
                }

              }
            );


            setActive(
              closestIndex
            );


            ticking = false;

          }
        );

      },
      {
        passive: true
      }
    );

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fragrance-deck"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initDeck(root) {

    var stack = root.querySelector('[data-deck-stack]');
    if (!stack) return;

    var cards = Array.prototype.slice.call(
      root.querySelectorAll('[data-deck-card]')
    );

    var entries = Array.prototype.slice.call(
      root.querySelectorAll('[data-deck-entry]')
    );

    var currentEl = root.querySelector('[data-deck-current]');
    var prevBtn = root.querySelector('[data-deck-prev]');
    var nextBtn = root.querySelector('[data-deck-next]');
    var hint = root.querySelector('[data-deck-hint]');

    var total = cards.length;
    if (total < 2) return;

    // order[0] is the card currently on top.
    var order = cards.map(function (_, i) { return i; });
    var busy = false;
    var touched = false;


    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }


    function render() {

      order.forEach(function (cardIndex, depth) {

        var card = cards[cardIndex];

        card.style.setProperty('--offset', depth);

        card.classList.toggle('is-front', depth === 0);
        card.classList.toggle('is-buried', depth > 3);

        card.classList.remove('is-thrown', 'is-dragged');
        card.style.removeProperty('transform');
      });

      var frontIndex = order[0];

      entries.forEach(function (entry) {
        entry.classList.toggle(
          'is-active',
          Number(entry.dataset.index) === frontIndex
        );
      });

      if (currentEl) {
        currentEl.textContent = pad(frontIndex + 1);
      }
    }


    function dismissHint() {
      if (touched || !hint) return;
      touched = true;
      hint.classList.add('is-dismissed');
    }


    /*
     * direction: 1 sends the top card to the back,
     * -1 pulls the back card to the front.
     */
    function advance(direction, throwX) {

      if (busy) return;
      busy = true;

      dismissHint();

      if (direction === 1) {

        var leaving = cards[order[0]];

        // Fling it off before it rejoins the bottom of the deck.
        leaving.classList.add('is-thrown');
        leaving.style.transform =
          'translate3d(' + (throwX || 420) + 'px, 40px, 0) ' +
          'rotate(' + ((throwX || 420) > 0 ? 22 : -22) + 'deg)';
        leaving.style.opacity = '0';

        window.setTimeout(function () {
          order.push(order.shift());
          leaving.style.removeProperty('opacity');
          render();
          busy = false;
        }, 300);

      } else {

        order.unshift(order.pop());
        render();

        window.setTimeout(function () {
          busy = false;
        }, 320);
      }
    }


    /* ---------- pointer drag ---------- */

    var dragging = false;
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var activeCard = null;


    stack.addEventListener('pointerdown', function (event) {

      if (busy) return;

      activeCard = cards[order[0]];
      if (!activeCard) return;

      dragging = true;
      startX = event.clientX;
      startY = event.clientY;
      dx = 0;

      activeCard.classList.add('is-dragged');
      stack.classList.add('is-dragging');
    });


    stack.addEventListener('pointermove', function (event) {

      if (!dragging || !activeCard) return;

      dx = event.clientX - startX;
      var dy = event.clientY - startY;

      // Let a clearly vertical gesture scroll the page instead.
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 14) {
        release(false);
        return;
      }

      activeCard.style.transform =
        'translate3d(' + dx + 'px, ' + (Math.abs(dx) * 0.06) + 'px, 0) ' +
        'rotate(' + (dx * 0.045) + 'deg)';
    });


    function release(allowThrow) {

      if (!dragging || !activeCard) return;

      dragging = false;
      stack.classList.remove('is-dragging');

      var card = activeCard;
      activeCard = null;

      if (allowThrow && Math.abs(dx) > 80) {
        advance(1, dx > 0 ? 460 : -460);
        return;
      }

      // Snap back.
      card.classList.remove('is-dragged');
      card.style.removeProperty('transform');

      // A tap rather than a drag.
      if (allowThrow && Math.abs(dx) < 6) {
        advance(1, 460);
      }
    }


    stack.addEventListener('pointerup', function () {
      release(true);
    });

    stack.addEventListener('pointercancel', function () {
      release(false);
    });

    stack.addEventListener('pointerleave', function () {
      release(false);
    });


    /* ---------- buttons and keyboard ---------- */

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        advance(1, 460);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        advance(-1);
      });
    }

    stack.setAttribute('tabindex', '0');

    stack.addEventListener('keydown', function (event) {

      if (event.key === 'ArrowRight' || event.key === ' ') {
        event.preventDefault();
        advance(1, 460);
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        advance(-1);
      }
    });


    render();
  }


  function initAll() {
    document
      .querySelectorAll('[data-fragrance-deck]')
      .forEach(initDeck);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }


  // Re-run when the block list changes in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-fragrance-deck]');
    if (root) initDeck(root);
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fragrance-product"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initProduct(root) {

    /* ---------- gallery ---------- */

    var frames = root.querySelectorAll('[data-fp-frame]');
    var thumbs = root.querySelectorAll('[data-fp-thumb]');

    if (thumbs.length) {

      thumbs.forEach(function (thumb) {

        thumb.addEventListener('click', function () {

          var index = thumb.dataset.index;

          frames.forEach(function (frame) {
            frame.classList.toggle('is-active', frame.dataset.index === index);
          });

          thumbs.forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });

      });

    }


    /* ---------- variant price ---------- */

    var select = root.querySelector('[data-fp-select]');
    var priceEl = root.querySelector('[data-fp-price]');

    if (select && priceEl) {

      select.addEventListener('change', function () {

        var option = select.options[select.selectedIndex];
        if (!option) return;

        var price = option.getAttribute('data-price');
        if (price) priceEl.textContent = price;
      });

    }
  }


  function initAll() {
    document.querySelectorAll('[data-fragrance-product]').forEach(initProduct);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }


  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-fragrance-product]');
    if (root) initProduct(root);
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.sectionHeader = this.closest('.section-header') || document.querySelector('.section-header');
      this.headerWrapper = this;
      this.header = this.querySelector('.header');
      this.stickyType = this.getAttribute('data-sticky-type');

      if (!this.sectionHeader || !this.header) return;

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    setHeaderHeight() {
      this.headerHeight = Math.round(this.headerWrapper.offsetHeight || this.header.offsetHeight || 0);
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
    }

    
onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollDelta = Math.abs(scrollTop - this.currentScrollTop);

  // Prevent the sticky header from reacting while
  // the mobile navigation drawer is open.
  const mobileDrawerOpen =
    window.innerWidth < 990 &&
    !!this.sectionHeader.querySelector(
      '#Details-menu-drawer-container[open]'
    );

  // Prevent keyboard-induced scrolling from hiding
  // the header while a drawer input is focused.
  const drawerInputFocused =
    window.innerWidth < 990 &&
    !!document.activeElement?.closest('#menu-drawer');

  if (mobileDrawerOpen || drawerInputFocused) {
    this.currentScrollTop = Math.max(0, scrollTop);
    return;
  }

  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
  if (scrollDelta < 6) return;

  if (scrollTop <= 1) {
    this.reset();
  } else {
    this.sectionHeader.classList.add('scrolled-past-header');

    if (scrollTop > this.currentScrollTop) {
      this.hide();
    } else {
      this.reveal();
    }
  }

  this.currentScrollTop = Math.max(0, scrollTop);
}


    hide() {
  this.sectionHeader.classList.remove('animate');
  this.sectionHeader.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
  this.closeMenuDisclosure();
  this.closeSearchModal();
}

reveal() {
  this.sectionHeader.classList.add('shopify-section-header-sticky');

  requestAnimationFrame(() => {
    this.sectionHeader.classList.add('animate');
    this.sectionHeader.classList.remove('shopify-section-header-hidden');
  });
}

    reset() {
  this.sectionHeader.classList.remove('animate');
  this.sectionHeader.classList.remove(
    'scrolled-past-header',
    'shopify-section-header-hidden',
    'shopify-section-header-sticky'
  );
}

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.sectionHeader.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.sectionHeader.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function each(list, fn) {
      Array.prototype.forEach.call(list, fn);
    }
    function pad(number) {
      return number < 10 ? '0' + number : String(number);
    }

    function initAbout(root) {
      if (!root || root.getAttribute('data-ls-ready') === 'true') return;
      root.setAttribute('data-ls-ready', 'true');
      root.classList.add('ls-about--js');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var hasObserver = 'IntersectionObserver' in window;

      /* Groups where one choice is shown at a time: the three words, the
         format picker, the founder tabs, the timeline and the making steps. */
      each(root.querySelectorAll('[data-ls-switch]'), function (group) {
        var triggers = group.querySelectorAll('[data-ls-trigger]');
        var panels = group.querySelectorAll('[data-ls-panel]');
        var counter = group.querySelector('[data-ls-count]');
        var state = group.getAttribute('data-ls-switch') === 'steps' ? 'aria-expanded' : 'aria-pressed';
        if (!triggers.length) return;

        function select(index) {
          var wanted = String(index);
          each(triggers, function (trigger) {
            var on = trigger.getAttribute('data-ls-trigger') === wanted;
            trigger.classList.toggle('is-active', on);
            trigger.setAttribute(state, on ? 'true' : 'false');
          });
          each(panels, function (panel) {
            panel.hidden = panel.getAttribute('data-ls-panel') !== wanted;
          });
          if (counter) counter.textContent = pad(Number(index) + 1);
        }

        each(triggers, function (trigger) {
          trigger.addEventListener('click', function () {
            select(trigger.getAttribute('data-ls-trigger'));
          });
        });
        group.lsSelect = select;
        select(0);
      });

      /* The promises open and close, one at a time. */
      each(root.querySelectorAll('[data-ls-accordion]'), function (accordion) {
        var items = accordion.querySelectorAll('[data-ls-item]');
        function open(target) {
          each(items, function (item) {
            var on = item === target;
            var button = item.querySelector('[data-ls-acc]');
            item.classList.toggle('is-open', on);
            if (button) button.setAttribute('aria-expanded', on ? 'true' : 'false');
          });
        }
        each(items, function (item) {
          var button = item.querySelector('[data-ls-acc]');
          if (!button) return;
          button.addEventListener('click', function () {
            open(item.classList.contains('is-open') ? null : item);
          });
        });
        accordion.lsOpen = open;
        open(items[0] || null);
      });

      /* Rows that swipe sideways: move the thin position bar where there is
         one, and flag rows that still have more to show. */
      each(root.querySelectorAll('[data-ls-swipe]'), function (row) {
        var next = row.nextElementSibling;
        var bar = next && next.hasAttribute('data-ls-swipe-bar') ? next : null;
        var thumb = bar ? bar.firstElementChild : null;
        function update() {
          var max = row.scrollWidth - row.clientWidth;
          row.classList.toggle('has-more', max > 2 && row.scrollLeft < max - 2);
          if (!bar) return;
          if (max <= 2) {
            bar.hidden = true;
            return;
          }
          bar.hidden = false;
          var track = bar.clientWidth;
          if (!track) return;
          var size = Math.max(track * (row.clientWidth / row.scrollWidth), track * 0.25);
          var pos = (row.scrollLeft / max) * (track - size);
          thumb.style.width = size + 'px';
          thumb.style.transform = 'translateX(' + pos + 'px)';
        }
        row.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });

      /* Fade the four points in as they enter the screen. */
      var reveal = root.querySelectorAll('[data-ls-reveal]');
      if (!reduce && hasObserver && reveal.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.remove('is-waiting');
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        each(reveal, function (el) {
          el.classList.add('is-waiting');
          observer.observe(el);
        });
      }
    }

    function initAll(scope) {
      each((scope || document).querySelectorAll('[data-ls-about]'), initAbout);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    /* In the theme editor, choosing a block brings its panel forward. */
    document.addEventListener('shopify:block:select', function (event) {
      var el = event.target;
      if (!el || !el.closest || !el.closest('[data-ls-about]')) return;
      var accordion = el.closest('[data-ls-accordion]');
      if (accordion && accordion.lsOpen && el.hasAttribute('data-ls-item')) {
        accordion.lsOpen(el);
        return;
      }
      var group = el.closest('[data-ls-switch]');
      if (!group || !group.lsSelect) return;
      var marked = el.hasAttribute('data-ls-panel') ? el : el.querySelector('[data-ls-trigger]');
      if (!marked) return;
      group.lsSelect(marked.getAttribute('data-ls-panel') || marked.getAttribute('data-ls-trigger'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-all-products-bottom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function countUp(el) {
      var text = el.textContent.trim();
      var match = text.match(/^(\d+(?:\.\d+)?)(.*)$/);
      if (!match) return;
      var target = parseFloat(match[1]);
      var decimals = (match[1].split('.')[1] || '').length;
      var suffix = match[2];
      var start = null;
      var duration = 1200;
      function frame(now) {
        if (!start) start = now;
        var t = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (t < 1) window.requestAnimationFrame(frame);
        else el.textContent = text;
      }
      window.requestAnimationFrame(frame);
    }
 
    function setupViewer(root, previews) {
      var viewer = root.querySelector('[data-apb-viewer]');
      if (!viewer) return;
      var openers = Array.prototype.slice.call(root.querySelectorAll('[data-apb-open]'));
      if (!openers.length) return;
      document.body.appendChild(viewer);
 
      var stories = openers.map(function (b) {
        return { src: b.getAttribute('data-src'), poster: b.getAttribute('data-poster'), title: b.getAttribute('data-title') };
      });
      var main = viewer.querySelector('[data-apb-vmain]');
      var track = viewer.querySelector('[data-apb-vtrack]');
      var numEl = viewer.querySelector('[data-apb-vnum]');
      var titleEl = viewer.querySelector('[data-apb-vtitle]');
      var soundBtn = viewer.querySelector('[data-apb-vsound]');
      var stage = viewer.querySelector('[data-apb-vstage]');
      var index = 0;
      var muted = false;
      var lastOpener = null;
      var savedOverflow = '';
 
      track.innerHTML = '';
      stories.forEach(function () {
        var bar = document.createElement('i');
        bar.appendChild(document.createElement('b'));
        track.appendChild(bar);
      });
      var fills = track.querySelectorAll('b');
 
      function paint(progress) {
        Array.prototype.forEach.call(fills, function (f, n) {
          f.style.width = (n < index ? 100 : n === index ? progress * 100 : 0) + '%';
        });
      }
 
      function show(n) {
        index = n;
        var st = stories[n];
        main.pause();
        if (st.poster) main.setAttribute('poster', st.poster); else main.removeAttribute('poster');
        main.src = st.src;
        main.muted = muted;
        main.currentTime = 0;
        var p = main.play();
        if (p && p.catch) {
          p.catch(function () {
            muted = true;
            main.muted = true;
            soundBtn.setAttribute('aria-pressed', 'false');
            main.play().catch(function () {});
          });
        }
        numEl.textContent = (n + 1 < 10 ? '0' : '') + (n + 1);
        titleEl.textContent = st.title || '';
        paint(0);
      }
 
      function next() {
        if (index < stories.length - 1) show(index + 1);
        else close();
      }
      function prev() {
        if (main.currentTime > 2 || index === 0) {
          main.currentTime = 0;
          main.play().catch(function () {});
        } else {
          show(index - 1);
        }
      }
 
      function open(n, opener) {
        lastOpener = opener || null;
        Array.prototype.forEach.call(previews, function (v) { v.pause(); });
        savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        viewer.hidden = false;
        window.requestAnimationFrame(function () { viewer.classList.add('is-open'); });
        soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
        show(n);
        document.addEventListener('keydown', onKey);
        soundBtn.focus({ preventScroll: true });
      }
 
      function close() {
        main.pause();
        main.removeAttribute('src');
        main.load();
        viewer.classList.remove('is-open');
        viewer.hidden = true;
        document.documentElement.style.overflow = savedOverflow;
        document.removeEventListener('keydown', onKey);
        if (lastOpener) lastOpener.focus({ preventScroll: true });
      }
 
      function onKey(event) {
        if (event.key === 'Escape') close();
        else if (event.key === 'ArrowRight') next();
        else if (event.key === 'ArrowLeft') prev();
      }
 
      openers.forEach(function (b, n) {
        b.addEventListener('click', function () { open(n, b); });
      });
      main.addEventListener('timeupdate', function () {
        if (main.duration) paint(main.currentTime / main.duration);
      });
      main.addEventListener('ended', next);
      main.addEventListener('click', function () {
        if (main.paused) main.play().catch(function () {}); else main.pause();
      });
      viewer.querySelector('[data-apb-vnext]').addEventListener('click', next);
      viewer.querySelector('[data-apb-vprev]').addEventListener('click', prev);
      viewer.querySelector('[data-apb-vclose]').addEventListener('click', close);
      soundBtn.addEventListener('click', function () {
        muted = !muted;
        main.muted = muted;
        soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
        if (!muted) main.play().catch(function () {});
      });
      viewer.addEventListener('click', function (event) {
        if (event.target === viewer) close();
      });
 
      var sx = null, sy = null;
      stage.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
        else if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) next(); else prev();
        }
        sx = null; sy = null;
      }, { passive: true });
    }
 
    function init(root) {
      if (!root || root.getAttribute('data-apb-ready')) return;
      root.setAttribute('data-apb-ready', '1');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var videos = root.querySelectorAll('[data-apb-video]');
 
      if ('IntersectionObserver' in window && videos.length) {
        var vObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting && !reduce) {
              if (v.preload === 'none') v.preload = 'auto';
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.35 });
        Array.prototype.forEach.call(videos, function (v) { vObserver.observe(v); });
      }
 
      setupViewer(root, videos);
 
      var steps = root.querySelector('[data-apb-steps]');
      var counters = root.querySelectorAll('[data-apb-count]');
      if (!('IntersectionObserver' in window) || reduce) {
        if (steps) steps.classList.add('is-drawn');
      } else {
        var once = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            once.unobserve(el);
            if (el.hasAttribute('data-apb-steps')) {
              el.classList.add('is-drawn');
            } else {
              countUp(el);
            }
          });
        }, { threshold: 0.4 });
        if (steps) once.observe(steps);
        Array.prototype.forEach.call(counters, function (el) { once.observe(el); });
      }
 
      if (!('IntersectionObserver' in window) || reduce || (window.Shopify && window.Shopify.designMode)) return;
      root.classList.add('is-ready');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px' });
      Array.prototype.forEach.call(root.querySelectorAll('[data-apb-reveal]'), function (el) { observer.observe(el); });
    }
 
    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ls-apb]'), init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-all-products-top"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function findTarget(href) {
      if (href === '#collection') return document.querySelector('.lescent-dior-collection');
      if (!href || href.charAt(0) !== '#') return null;
      try {
        return document.querySelector(href);
      } catch (e) {
        return null;
      }
    }
 
    function headerOffset() {
      var header = document.querySelector('.section-header');
      return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    }
 
    function setupBar(root) {
      var bar = root.querySelector('[data-apt-bar-nav]');
      if (!bar) return;
      var hero = root.querySelector('.ls-apt__hero');
      var fill = bar.querySelector('[data-apt-bar-fill]');
      var footer = document.querySelector('footer, .footer, .shopify-section-group-footer-group');
      var items = [];
      Array.prototype.forEach.call(bar.querySelectorAll('[data-apt-bar-link]'), function (link) {
        var target = findTarget(link.getAttribute('href'));
        if (target) {
          items.push({ link: link, target: target });
        } else {
          link.parentNode.parentNode.removeChild(link.parentNode);
        }
      });
      if (items.length < 2) return;
      bar.hidden = false;
 
      bar.addEventListener('click', function (event) {
        var link = event.target.closest('[data-apt-bar-link]');
        if (!link) return;
        var item = items.filter(function (it) { return it.link === link; })[0];
        if (!item) return;
        event.preventDefault();
        var top = item.target.getBoundingClientRect().top + window.pageYOffset - headerOffset() + 1;
        var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
      });
 
      var ticking = false;
      var lastActive = null;
      function update() {
        ticking = false;
        var vh = window.innerHeight;
        bar.style.setProperty('--apt-bar-top', (headerOffset() + 8) + 'px');
        var pastHero = hero ? hero.getBoundingClientRect().bottom < vh * 0.35 : window.pageYOffset > vh;
        var nearFooter = footer ? footer.getBoundingClientRect().top < vh * 0.9 : false;
        bar.classList.toggle('is-shown', pastHero && !nearFooter);
 
        var line = headerOffset() + vh * 0.3;
        var active = null;
        items.forEach(function (it) {
          if (it.target.getBoundingClientRect().top <= line) active = it;
        });
        items.forEach(function (it) { it.link.classList.toggle('is-active', it === active); });
        if (active && active !== lastActive) {
          lastActive = active;
          var list = active.link.closest('.ls-apt__bar-list');
          if (list && list.scrollWidth > list.clientWidth) {
            var li = active.link.parentNode;
            list.scrollTo({ left: li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2, behavior: 'smooth' });
          }
        }
 
        if (fill) {
          var first = items[0].target.getBoundingClientRect().top + window.pageYOffset;
          var last = items[items.length - 1].target;
          var end = last.getBoundingClientRect().bottom + window.pageYOffset - vh;
          var pct = end > first ? (window.pageYOffset - first) / (end - first) : 0;
          fill.style.width = Math.max(0, Math.min(1, pct)) * 100 + '%';
        }
      }
      function queue() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      update();
    }
 
    function init(root) {
      if (!root || root.getAttribute('data-apt-ready')) return;
      root.setAttribute('data-apt-ready', '1');
 
      root.addEventListener('click', function (event) {
        var link = event.target.closest('[data-apt-to-grid]');
        if (!link) return;
        var grid = document.querySelector('.lescent-dior-collection');
        if (!grid) return;
        event.preventDefault();
        var header = document.querySelector('.section-header');
        var offset = header ? header.getBoundingClientRect().height : 0;
        var top = grid.getBoundingClientRect().top + window.pageYOffset - offset;
        var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
      });
 
      var track = root.querySelector('[data-apt-track]');
      var bar = root.querySelector('[data-apt-bar]');
      if (track && bar) {
        var update = function () {
          var max = track.scrollWidth - track.clientWidth;
          var share = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
          bar.style.width = Math.max(share * 100, 12) + '%';
          var room = 100 / Math.max(share, 0.01) - 100;
          bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * room : 0) + '%)';
        };
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
 
      setupBar(root);
 
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && window.Shopify.designMode)) {
        return;
      }
      root.classList.add('is-ready');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px' });
      Array.prototype.forEach.call(root.querySelectorAll('[data-apt-reveal]'), function (el) {
        observer.observe(el);
      });
    }
 
    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ls-apt]'), init);
    }
 
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function slug(text, used) {
    var base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'part';
    var id = base;
    var n = 2;
    while (used[id] || (document.getElementById(id) && !document.getElementById(id).hasAttribute('data-lp-heading'))) {
      id = base + '-' + n;
      n += 1;
    }
    used[id] = true;
    return id;
  }

  function setUp(root) {
    if (!root || root.hasAttribute('data-lp-ready')) return;
    root.setAttribute('data-lp-ready', '');

    var content = root.querySelector('[data-lp-content]');
    var desktop = window.matchMedia('(min-width: 1100px)');
    var cleanups = [];

    /* Wide tables scroll sideways on phones instead of squashing. */
    if (content) {
      each(content.querySelectorAll('table'), function (table) {
        if (table.parentElement && table.parentElement.classList.contains('ls-post__table')) return;
        var box = document.createElement('div');
        box.className = 'ls-post__table';
        table.parentNode.insertBefore(box, table);
        box.appendChild(table);
      });
    }

    /* A link on its own line, like "Browse the range", becomes a button.
       Links next to each other sit together in one row. */
    if (content && root.getAttribute('data-cta') === 'true') {
      var group = null;
      Array.prototype.slice.call(content.children).forEach(function (el) {
        var link = el.tagName === 'P' && el.children.length === 1 ? el.querySelector('a[href]') : null;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        var solo = link && !link.querySelector('img') && text.length > 0 && text.length < 60 &&
          text === (link.textContent || '').replace(/\s+/g, ' ').trim() && link.getAttribute('href').charAt(0) !== '#';
        if (!solo) {
          group = null;
          return;
        }
        if (!group || group.nextSibling !== el) {
          group = document.createElement('div');
          group.className = 'ls-post__ctas';
          content.insertBefore(group, el);
        }
        group.appendChild(el);
      });
    }

    /* Keep things just under the site header when it sticks to the top. */
    var setStick = function () {
      var top = 0;
      each(document.querySelectorAll('.section-header, sticky-header, .shopify-section-group-header-group'), function (el) {
        var position = window.getComputedStyle(el).position;
        if (position !== 'sticky' && position !== 'fixed') return;
        var box = el.getBoundingClientRect();
        if (box.top <= 1 && box.bottom > 0 && box.bottom < window.innerHeight / 2) {
          top = Math.max(top, Math.round(box.bottom));
        }
      });
      root.style.setProperty('--lp-stick', top + 'px');
    };

    /* On this page, built from the post's own headings. */
    var toc = root.querySelector('[data-lp-toc]');
    var list = root.querySelector('[data-lp-toc-list]');
    var heads = [];
    var links = [];
    if (toc && list && content) {
      var min = Number(root.getAttribute('data-toc-min')) || 2;
      var used = {};
      var found = content.querySelectorAll('h2, h3');
      var h2s = content.querySelectorAll('h2').length;
      each(found, function (h) {
        var text = (h.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return;
        if (h.tagName === 'H3' && h2s === 0) return;
        if (!h.id) h.id = slug(text, used);
        h.setAttribute('data-lp-heading', '');
        heads.push(h);
      });
      if (heads.filter(function (h) { return h.tagName === 'H2'; }).length >= min) {
        list.innerHTML = '';
        heads.forEach(function (h) {
          var li = document.createElement('li');
          if (h.tagName === 'H3') li.className = 'is-sub';
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = (h.textContent || '').replace(/\s+/g, ' ').trim();
          a.addEventListener('click', function (event) {
            event.preventDefault();
            /* Close the phone list first so the page does not shift after
               the jump starts. */
            if (!desktop.matches) toc.open = false;
            setStick();
            h.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            if (history.replaceState) history.replaceState(null, '', '#' + h.id);
          });
          li.appendChild(a);
          list.appendChild(li);
          links.push(a);
        });
        toc.hidden = false;
        var syncOpen = function () {
          toc.open = desktop.matches;
        };
        syncOpen();
        if (desktop.addEventListener) {
          desktop.addEventListener('change', syncOpen);
          cleanups.push(function () { desktop.removeEventListener('change', syncOpen); });
        }
      } else {
        heads = [];
      }
    }

    /* No list to show: the share buttons at the end are enough, so the
       post sits in one centred column. */
    if (!heads.length) {
      var aside = root.querySelector('.ls-post__aside');
      if (aside) {
        aside.hidden = true;
        aside.parentElement.classList.add('ls-post__body--single');
      }
    }

    /* Progress line and the current heading, both from one scroll read. */
    var bar = root.querySelector('[data-lp-progress]');
    var left = root.querySelector('[data-lp-left]');
    var minutes = Number(root.getAttribute('data-minutes')) || 1;
    var leftWord = root.getAttribute('data-left') || 'min left';
    var doneWord = root.getAttribute('data-done') || '';
    var current = -1;
    var queued = false;
    var update = function () {
      queued = false;
      setStick();
      var view = window.innerHeight;
      if (bar && content) {
        var box = content.getBoundingClientRect();
        var total = box.height - view * 0.6;
        var done = total > 0 ? (view * 0.4 - box.top) / total : 1;
        done = Math.max(0, Math.min(1, done));
        bar.style.transform = 'scaleX(' + done.toFixed(4) + ')';
      }
      if (left && content) {
        var cbox = content.getBoundingClientRect();
        var span = cbox.height - view * 0.6;
        var read = span > 0 ? Math.max(0, Math.min(1, (view * 0.4 - cbox.top) / span)) : 1;
        var mins = Math.ceil(minutes * (1 - read) - 0.05);
        var say = read >= 0.98 || mins < 1 ? doneWord : mins + ' ' + leftWord;
        if (left.textContent !== say) left.textContent = say;
      }
      if (heads.length) {
        var line = (parseFloat(root.style.getPropertyValue('--lp-stick')) || 0) + view * 0.25;
        var index = -1;
        for (var i = 0; i < heads.length; i += 1) {
          if (heads[i].getBoundingClientRect().top <= line) index = i;
        }
        if (index !== current) {
          current = index;
          links.forEach(function (a, k) {
            a.classList.toggle('is-current', k === index);
            if (k === index) a.setAttribute('aria-current', 'location');
            else a.removeAttribute('aria-current');
          });
        }
      }
    };
    var queue = function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    cleanups.push(function () {
      window.removeEventListener('scroll', queue);
      window.removeEventListener('resize', queue);
    });
    each(root.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', queue, { once: true });
    });
    update();

    /* Share */
    var copied = root.getAttribute('data-copied') || 'Link copied';
    var shareData = { title: document.title, url: window.location.href.split('#')[0] };
    each(root.querySelectorAll('[data-lp-copy]'), function (btn) {
      var label = btn.querySelector('[data-lp-copy-text]');
      var original = label ? label.textContent : '';
      var timer = null;
      btn.addEventListener('click', function () {
        var done = function () {
          if (label) label.textContent = copied;
          btn.classList.add('is-done');
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (label) label.textContent = original;
            btn.classList.remove('is-done');
          }, 2200);
        };
        var fallback = function () {
          var field = document.createElement('textarea');
          field.value = shareData.url;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          try {
            document.execCommand('copy');
            done();
          } catch (e) {}
          document.body.removeChild(field);
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(shareData.url).then(done, fallback);
        } else {
          fallback();
        }
      });
    });
    if (navigator.share) {
      each(root.querySelectorAll('[data-lp-native]'), function (btn) {
        btn.hidden = false;
        btn.addEventListener('click', function () {
          navigator.share(shareData).catch(function () {});
        });
      });
    }

    root._lpCleanup = function () {
      cleanups.forEach(function (fn) { fn(); });
    };
  }

  function start(scope) {
    each((scope || document).querySelectorAll('[data-ls-post]'), setUp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    start(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    each(event.target.querySelectorAll('[data-ls-post]'), function (root) {
      if (root._lpCleanup) root._lpCleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function each(list, fn) {
      Array.prototype.forEach.call(list, fn);
    }

    function initBundle(root) {
      if (!root || root.getAttribute('data-ls-ready') === 'true') return;
      root.setAttribute('data-ls-ready', 'true');
      root.classList.add('ls-bundle--js');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var words = {
        upto: root.getAttribute('data-upto') || '',
        item: root.getAttribute('data-item') || 'item',
        items: root.getAttribute('data-items') || 'items',
        save: root.getAttribute('data-text-save') || '',
        none: root.getAttribute('data-text-none') || '',
        next: root.getAttribute('data-text-next') || '',
        top: root.getAttribute('data-text-top') || ''
      };
      var chips = root.querySelectorAll('[data-lb-chip]');
      var panels = root.querySelectorAll('[data-lb-panel]');

      function readTiers(panel) {
        var list = [];
        each(panel.querySelectorAll('[data-lb-tier]'), function (el) {
          list.push({ el: el, min: Number(el.getAttribute('data-min')), pct: Number(el.getAttribute('data-pct')) });
        });
        return list;
      }

      /* The counter under each ladder. */
      each(panels, function (panel) {
        var counter = panel.querySelector('[data-lb-counter]');
        if (!counter) return;
        var qtyEl = counter.querySelector('[data-lb-qty]');
        var saveEl = counter.querySelector('[data-lb-save]');
        var nextEl = counter.querySelector('[data-lb-next]');
        var qty = null;

        function render() {
          var tiers = readTiers(panel);
          if (!tiers.length) {
            counter.hidden = true;
            return;
          }
          counter.hidden = false;
          if (qty === null) qty = tiers[0].min;
          var saved = 0;
          var next = null;
          tiers.forEach(function (tier) {
            var reached = qty >= tier.min;
            tier.el.classList.toggle('is-reached', reached);
            if (reached) saved = tier.pct;
            else if (!next) next = tier;
          });
          qtyEl.textContent = qty + ' ' + (qty === 1 ? words.item : words.items);
          saveEl.textContent = saved ? words.save.replace('{pct}', saved) : words.none;
          nextEl.textContent = next
            ? words.next.replace('{n}', next.min - qty).replace('{pct}', next.pct)
            : words.top;
        }
        function step(change) {
          var tiers = readTiers(panel);
          if (!tiers.length) return;
          var max = tiers[tiers.length - 1].min + 2;
          qty = Math.min(max, Math.max(1, (qty === null ? tiers[0].min : qty) + change));
          render();
        }
        counter.querySelector('[data-lb-less]').addEventListener('click', function () {
          step(-1);
        });
        counter.querySelector('[data-lb-more]').addEventListener('click', function () {
          step(1);
        });
        panel.lbReset = function () {
          qty = null;
          render();
        };
        render();
      });

      /* Choosing a bundle. */
      function select(index) {
        var wanted = String(index);
        each(chips, function (chip) {
          var on = chip.getAttribute('data-lb-chip') === wanted;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        each(panels, function (panel) {
          var on = panel.getAttribute('data-lb-panel') === wanted;
          panel.classList.toggle('is-off', !on);
          if (on) panel.removeAttribute('aria-hidden');
          else panel.setAttribute('aria-hidden', 'true');
          if (on) root.setAttribute('data-lb-stage', panel.getAttribute('data-lb-stage') || 'idle');
        });
      }
      each(chips, function (chip) {
        chip.addEventListener('click', function () {
          select(chip.getAttribute('data-lb-chip'));
        });
      });
      root.lbSelect = select;
      if (panels.length) select(0);

      /* The chip row swipes on small screens. */
      each(root.querySelectorAll('[data-lb-swipe]'), function (row) {
        /* A thin progress bar under the row shows there is more to swipe. */
        var bar = document.createElement('div');
        bar.className = 'ls-bundle__swipe-bar';
        bar.setAttribute('aria-hidden', 'true');
        var thumb = document.createElement('span');
        bar.appendChild(thumb);
        row.parentNode.insertBefore(bar, row.nextSibling);
        function update() {
          var max = row.scrollWidth - row.clientWidth;
          row.classList.toggle('has-more', max > 2 && row.scrollLeft < max - 2);
          bar.hidden = max <= 2;
          if (max > 2) {
            var w = Math.max(18, (row.clientWidth / row.scrollWidth) * 100);
            thumb.style.width = w + '%';
            thumb.style.transform = 'translateX(' + ((row.scrollLeft / max) * (100 - w) / w * 100) + '%)';
          }
        }
        row.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });

      /* Take the real tiers from the Bundler app when it is on the page, so
         the ladder always matches what customers are charged. A bundle's
         code is its Bundler id written in base 36. */
      function applyLive() {
        if (!window.bndlr || typeof window.bndlr.getBundles !== 'function') return false;
        var bundles;
        try {
          bundles = window.bndlr.getBundles();
        } catch (error) {
          return true;
        }
        if (!bundles || !bundles.length) return false;

        each(panels, function (panel) {
          var code = (panel.getAttribute('data-lb-code') || '').toLowerCase();
          var ladder = panel.querySelector('[data-lb-ladder]');
          if (!code || !ladder || !/^[0-9a-z]+$/.test(code)) return;
          var id = parseInt(code, 36);
          var match = null;
          each(bundles, function (bundle) {
            if (Number(bundle.id) === id) match = bundle;
          });
          if (!match || !match.volume_discounts || !match.volume_discounts.length) return;

          var tiers = [];
          each(match.volume_discounts, function (row) {
            var min = Number(row.min_items);
            var pct = Number(row.discount_value);
            if (row.discount_type === 'percentage' && min > 0 && pct > 0) tiers.push({ min: min, pct: pct });
          });
          if (!tiers.length) return;
          tiers.sort(function (a, b) {
            return a.min - b.min;
          });

          while (ladder.firstChild) ladder.removeChild(ladder.firstChild);
          tiers.forEach(function (tier, position) {
            var item = document.createElement('li');
            var pct = document.createElement('span');
            var label = document.createElement('span');
            item.className = 'ls-bundle__tier';
            item.setAttribute('data-lb-tier', '');
            item.setAttribute('data-min', tier.min);
            item.setAttribute('data-pct', tier.pct);
            pct.className = 'ls-bundle__tier-pct';
            pct.textContent = tier.pct + '%';
            label.className = 'ls-bundle__tier-label';
            label.textContent = tier.min + (position === tiers.length - 1 ? '+' : '') + ' ' + words.items;
            item.appendChild(pct);
            item.appendChild(label);
            ladder.appendChild(item);
          });

          var chip = root.querySelector('[data-lb-chip="' + panel.getAttribute('data-lb-panel') + '"] [data-lb-chip-note]');
          if (chip) chip.textContent = (words.upto + ' ' + tiers[tiers.length - 1].pct + '%').trim();
          if (panel.lbReset) panel.lbReset();
        });

        var top = 0;
        each(root.querySelectorAll('[data-lb-panel] [data-lb-tier]'), function (el) {
          top = Math.max(top, Number(el.getAttribute('data-pct')) || 0);
        });
        if (top) {
          each(root.querySelectorAll('[data-lb-top]'), function (el) {
            el.textContent = top + '%';
          });
        }
        return true;
      }
      if (root.getAttribute('data-live') === 'true') {
        var tries = 0;
        var timer = window.setInterval(function () {
          tries += 1;
          if (applyLive() || tries > 25) window.clearInterval(timer);
        }, 400);
      }

      /* The assistant bar. It watches the Bundler app's builder and says
         what to do next: add a product, keep going, or press the app's
         Add Bundle to Cart. Class names are the app's own. If the app's
         parts cannot be found, the bar keeps its general instruction. */
      var say = {
        idle: root.getAttribute('data-say-idle') || '',
        start: root.getAttribute('data-say-start') || '',
        building: root.getAttribute('data-say-building') || '',
        ready: root.getAttribute('data-say-ready') || '',
        final: root.getAttribute('data-say-final') || ''
      };
      var tag = {
        idle: root.getAttribute('data-tag-idle') || '',
        start: root.getAttribute('data-tag-start') || '',
        building: root.getAttribute('data-tag-building') || '',
        ready: root.getAttribute('data-tag-ready') || ''
      };
      var bars = root.querySelectorAll('[data-lb-status]');

      function shown(el) {
        return !!el && !el.closest('.bndlr-hidden') && el.getClientRects().length > 0;
      }
      function clean(el) {
        return shown(el) ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
      }

      each(panels, function (panel) {
        var bar = panel.querySelector('[data-lb-status]');
        var widget = panel.querySelector('.ls-bundle__widget');
        if (!bar || !widget) return;
        var labelEl = bar.querySelector('[data-lb-status-label]');
        var textEl = bar.querySelector('[data-lb-status-text]');
        var go = bar.querySelector('[data-lb-status-go]');
        var most = null;
        var last = '';
        var queued = false;

        if (say.final) {
          panel.style.setProperty('--lb-final-hint', '"' + say.final.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"');
        }

        function read() {
          var cart = widget.querySelector('.bndlr-add-bundle-to-cart');
          if (!cart) return { stage: 'idle', note: '' };
          if (shown(cart)) {
            return { stage: 'ready', note: clean(widget.querySelector('.bndlr-tiered-mnm-instructions-text')) };
          }
          var need = clean(widget.querySelector('.bndlr-mnm-instructions-text'));
          var found = /(\d+)/.exec(need);
          var left = found ? Number(found[1]) : null;
          if (left !== null && (most === null || left > most)) most = left;
          var picked = widget.querySelector('.bndlr-mnm-selected-products');
          var started = (shown(picked) && picked.children.length > 0) || (left !== null && most !== null && left < most);
          return { stage: started ? 'building' : 'start', note: started ? need : '' };
        }

        function render() {
          queued = false;
          var now = read();
          var text = say[now.stage] || say.idle;
          if (now.note) text = now.stage === 'ready' ? text + ' ' + now.note : now.note + ' ' + text;
          var key = now.stage + '|' + text;
          if (key === last) return;
          var first = last === '';
          last = key;
          panel.setAttribute('data-lb-stage', now.stage);
          if (!panel.classList.contains('is-off')) root.setAttribute('data-lb-stage', now.stage);
          if (labelEl) labelEl.textContent = tag[now.stage] || tag.idle;
          if (textEl) textEl.textContent = text;
          if (go) go.hidden = now.stage !== 'ready';
          if (!first && !reduce) {
            bar.classList.remove('is-flash');
            void bar.offsetWidth;
            bar.classList.add('is-flash');
          }
        }
        function queue() {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(render);
        }

        if (go) {
          go.addEventListener('click', function () {
            var cart = widget.querySelector('.bndlr-add-bundle-to-cart');
            if (!cart) return;
            cart.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            cart.classList.remove('ls-bundle-point');
            void cart.offsetWidth;
            cart.classList.add('ls-bundle-point');
          });
        }

        if ('MutationObserver' in window) {
          new MutationObserver(queue).observe(widget, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden']
          });
        }
        render();
      });

      /* Keep the bar just under the site header when the header is fixed
         to the top of the screen. */
      if (bars.length) {
        var stickQueued = false;
        var setStick = function () {
          stickQueued = false;
          var top = 0;
          each(document.querySelectorAll('.section-header, sticky-header, .shopify-section-group-header-group'), function (el) {
            var position = window.getComputedStyle(el).position;
            if (position !== 'sticky' && position !== 'fixed') return;
            var box = el.getBoundingClientRect();
            if (box.top <= 1 && box.bottom > 0 && box.bottom < window.innerHeight / 2) {
              top = Math.max(top, Math.round(box.bottom));
            }
          });
          root.style.setProperty('--lb-stick', top + 'px');
        };
        var queueStick = function () {
          if (stickQueued) return;
          stickQueued = true;
          window.requestAnimationFrame(setStick);
        };
        window.addEventListener('scroll', queueStick, { passive: true });
        window.addEventListener('resize', queueStick);
        setStick();
      }

      /* Fade the steps and member tiers in as they enter the screen. */
      var reveal = root.querySelectorAll('[data-lb-reveal]');
      if (!reduce && 'IntersectionObserver' in window && reveal.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.remove('is-waiting');
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        each(reveal, function (el) {
          el.classList.add('is-waiting');
          observer.observe(el);
        });
      }
    }

    function initAll(scope) {
      each((scope || document).querySelectorAll('[data-ls-bundle]'), initBundle);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    /* In the theme editor: set up again after a change, ask the app to
       fill the builders again, and bring a chosen bundle forward. */
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
      if (!event.target.querySelector || !event.target.querySelector('[data-ls-bundle]')) return;
      if (window.bndlr && typeof window.bndlr.refresh === 'function') {
        try {
          window.bndlr.refresh();
        } catch (error) {}
      }
    });
    document.addEventListener('shopify:block:select', function (event) {
      var el = event.target;
      if (!el || !el.closest || !el.hasAttribute('data-lb-panel')) return;
      var root = el.closest('[data-ls-bundle]');
      if (root && root.lbSelect) root.lbSelect(el.getAttribute('data-lb-panel'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-craft"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function each(list, fn) {
      Array.prototype.forEach.call(list, fn);
    }

    function initCraft(root) {
      if (!root || root.getAttribute('data-ls-ready') === 'true') return;
      root.setAttribute('data-ls-ready', 'true');
      root.classList.add('ls-craft--js');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var design = root.getAttribute('data-design') === 'true';
      var showFormat = null;

      /* The price. A switch between the two bottles. It starts on the
         designer bottle and flips once by itself when it comes into view. */
      each(root.querySelectorAll('[data-lf-ledger]'), function (ledger) {
        var buttons = ledger.querySelectorAll('[data-lf-mode]');
        var touched = false;

        function setMode(mode) {
          ledger.setAttribute('data-mode', mode);
          each(buttons, function (button) {
            var on = button.getAttribute('data-lf-mode') === mode;
            button.classList.toggle('is-active', on);
            button.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }

        each(buttons, function (button) {
          button.addEventListener('click', function () {
            touched = true;
            setMode(button.getAttribute('data-lf-mode'));
          });
        });

        if (!reduce && !design && 'IntersectionObserver' in window) {
          setMode('theirs');
          var watcher = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                watcher.disconnect();
                window.setTimeout(function () {
                  if (!touched) setMode('ours');
                }, 1400);
              });
            },
            { threshold: 0.55 }
          );
          watcher.observe(ledger);
        }
      });

      /* The formats. Tabs. */
      var range = root.querySelector('[data-lf-formats]');
      if (range) {
        var tabs = range.querySelectorAll('[data-lf-tab]');
        var panels = range.querySelectorAll('[data-lf-panel]');
        var row = range.querySelector('[data-lf-swipe]');

        showFormat = function (index) {
          each(tabs, function (tab, i) {
            var on = i === index;
            tab.classList.toggle('is-active', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.setAttribute('tabindex', on ? '0' : '-1');
          });
          each(panels, function (panel, i) {
            panel.classList.toggle('is-active', i === index);
          });
          if (row && row.scrollWidth > row.clientWidth + 2) {
            var left = Math.max(0, tabs[index].offsetLeft - 15);
            if (typeof row.scrollTo === 'function') {
              row.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
            } else {
              row.scrollLeft = left;
            }
          }
        };

        each(tabs, function (tab, i) {
          tab.addEventListener('click', function () {
            showFormat(i);
          });
          tab.addEventListener('keydown', function (event) {
            var next = -1;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next < 0) return;
            event.preventDefault();
            showFormat(next);
            tabs[next].focus();
          });
        });
      }

      /* The tab row swipes on small screens. */
      each(root.querySelectorAll('[data-lf-swipe]'), function (swipe) {
        function update() {
          var max = swipe.scrollWidth - swipe.clientWidth;
          swipe.classList.toggle('has-more', max > 2 && swipe.scrollLeft < max - 2);
        }
        swipe.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });

      /* In the theme editor, show the format that was picked. */
      root.addEventListener('shopify:block:select', function (event) {
        var target = event.target;
        if (!target || !target.hasAttribute) return;
        if (target.hasAttribute('data-lf-tab') && showFormat) {
          showFormat(Array.prototype.indexOf.call(target.parentNode.children, target));
        }
      });

      /* Fade parts in as they enter the screen. */
      var reveal = root.querySelectorAll('[data-lf-reveal]');
      if (!reduce && !design && 'IntersectionObserver' in window && reveal.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.remove('is-waiting');
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -6% 0px' }
        );
        each(reveal, function (el) {
          el.classList.add('is-waiting');
          observer.observe(el);
        });
      }
    }

    function initAll(scope) {
      each((scope || document).querySelectorAll('[data-ls-craft]'), initCraft);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (!root || root.getAttribute('data-ls-ready') === 'true') return;
      root.setAttribute('data-ls-ready', 'true');

      var oneOpen = root.getAttribute('data-one-open') === 'true';
      var openFirst = root.getAttribute('data-open-first') === 'true';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-ls-faq-item]'));
      if (!items.length) return;

      function setOpen(item, open) {
        var trigger = item.querySelector('[data-ls-faq-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        item.classList.toggle('is-open', open);
      }

      function firstVisible() {
        for (var i = 0; i < items.length; i++) {
          if (!items[i].hidden) return items[i];
        }
        return null;
      }

      items.forEach(function (item) {
        setOpen(item, false);
        var trigger = item.querySelector('[data-ls-faq-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          if (oneOpen && willOpen) {
            items.forEach(function (other) {
              if (other !== item) setOpen(other, false);
            });
          }
          setOpen(item, willOpen);
        });
      });
      root.classList.add('ls-faq--js');
      if (openFirst && items[0]) setOpen(items[0], true);

      var chipWrap = root.querySelector('[data-ls-faq-chips]');
      if (!chipWrap) return;
      var chips = Array.prototype.slice.call(chipWrap.querySelectorAll('[data-ls-faq-filter]'));
      chipWrap.hidden = false;

      /* Position bar for the filter row when it swipes sideways. */
      var bar = root.querySelector('[data-ls-faq-bar]');
      if (bar) {
        var thumb = bar.firstElementChild;
        var updateBar = function () {
          var max = chipWrap.scrollWidth - chipWrap.clientWidth;
          if (max <= 2) {
            bar.hidden = true;
            return;
          }
          bar.hidden = false;
          var track = bar.clientWidth;
          if (!track) return;
          var size = Math.max(track * (chipWrap.clientWidth / chipWrap.scrollWidth), track * 0.25);
          var pos = (chipWrap.scrollLeft / max) * (track - size);
          thumb.style.width = size + 'px';
          thumb.style.transform = 'translateX(' + pos + 'px)';
        };
        chipWrap.addEventListener('scroll', updateBar, { passive: true });
        window.addEventListener('resize', updateBar);
        updateBar();
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var filter = chip.getAttribute('data-ls-faq-filter');
          chips.forEach(function (other) {
            other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
          });
          items.forEach(function (item) {
            var show = filter === 'all' || item.getAttribute('data-category') === filter;
            item.hidden = !show;
            if (!show) setOpen(item, false);
          });
          if (openFirst) {
            var anyOpen = items.some(function (item) {
              return !item.hidden && item.classList.contains('is-open');
            });
            var first = firstVisible();
            if (!anyOpen && first) setOpen(first, true);
          }
        });
      });
    }

    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ls-faq]'), initFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-guides"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (!root || root.getAttribute('data-gd-ready')) return;
      root.setAttribute('data-gd-ready', '1');
      var track = root.querySelector('[data-gd-track]');
      var bar = root.querySelector('[data-gd-bar]');
      if (!track || !bar) return;
      var thumb = bar.querySelector('span');
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        bar.hidden = max <= 2;
        if (bar.hidden) return;
        var w = Math.max(18, (track.clientWidth / track.scrollWidth) * 100);
        thumb.style.width = w + '%';
        thumb.style.transform = 'translateX(' + ((track.scrollLeft / max) * (100 - w) / w * 100) + '%)';
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function all(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ls-guides]'), setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
    else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var FORMATS = [
      { re: /roll[- ]?on/i, label: 'Roll-On', strip: /\s*(Roll-On Impérial Perfume Oil|Roll-On Perfume Oil|Perfume Oil Roll On|Roll-On)\s*$/i },
      { re: /hair mist/i, label: 'Hair Mist', strip: /\s*(Perfume Hair Mist|Hair Mist)\s*$/i },
      { re: /room|interior/i, label: 'Room Spray', strip: /\s*(Room Fragrance|Room Spray|Interior Fragrance)\s*$/i },
      { re: /primer|booster|enhancer|eau de parfum/i, label: 'Primer', strip: /\s*(50ml Eau De Parfum)\s*$/i },
      { re: /perfume fragrance/i, label: 'Perfume', strip: /\s*(Perfume Fragrance)\s*$/i }
    ];

    function describe(p) {
      var title = String(p.title || '');
      var type = String(p.type || p.product_type || '');
      var parts = title.split(' - ');
      var name = parts.shift().replace(/^No\.?\s*\d+\s*/i, '').trim();
      var sub = parts.join(' - ');
      var fmt = '';
      var probe = type || title;
      for (var i = 0; i < FORMATS.length; i++) {
        if (FORMATS[i].re.test(probe) || FORMATS[i].re.test(title)) {
          fmt = FORMATS[i].label;
          sub = sub.replace(FORMATS[i].strip, '');
          name = name.replace(FORMATS[i].strip, '');
          break;
        }
      }
      return { name: name.trim(), sub: sub.trim(), format: fmt };
    }

    function headerOffset() {
      var header = document.querySelector('.section-header');
      return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    }

    function setupTypewriter(input) {
      var names = (input.getAttribute('data-names') || '').split(',').map(function (n) { return n.trim(); }).filter(Boolean);
      var prefix = input.getAttribute('data-prefix') || '';
      if (names.length < 2 || reduce) return;
      var i = 0, pos = 0, deleting = false, timer = null, stopped = false;
      function tick() {
        if (stopped) return;
        var word = names[i];
        if (!deleting) {
          pos++;
          if (pos >= word.length) { deleting = true; timer = setTimeout(tick, 1600); input.placeholder = prefix + ' ' + word; return; }
        } else {
          pos--;
          if (pos <= 0) { deleting = false; i = (i + 1) % names.length; }
        }
        input.placeholder = prefix + ' ' + word.slice(0, Math.max(pos, 0));
        timer = setTimeout(tick, deleting ? 45 : 85);
      }
      function stop() { stopped = true; clearTimeout(timer); input.placeholder = prefix + ' ' + names[0]; }
      input.addEventListener('focus', stop, { once: true });
      timer = setTimeout(tick, 1400);
    }

    function setupSearch(root) {
      var form = root.querySelector('[data-hh-search]');
      if (!form) return;
      var input = form.querySelector('[data-hh-input]');
      var box = form.querySelector('[data-hh-results]');
      var live = form.querySelector('[data-hh-live]');
      var suggestUrl = root.getAttribute('data-suggest-url');
      var searchUrl = root.getAttribute('data-search-url');
      var symbol = root.getAttribute('data-currency') || '$';
      var timer = null, controller = null, items = [], active = -1;

      setupTypewriter(input);

      function close() {
        box.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        active = -1;
      }
      function setActive(n) {
        items.forEach(function (el, idx) {
          el.classList.toggle('is-active', idx === n);
          el.setAttribute('aria-selected', idx === n ? 'true' : 'false');
        });
        active = n;
        if (items[n]) items[n].scrollIntoView({ block: 'nearest' });
      }
      function price(p) {
        var n = parseFloat(p);
        if (isNaN(n)) return '';
        return symbol + n.toFixed(2);
      }
      function render(q, products) {
        var all = searchUrl + '?type=product&q=' + encodeURIComponent(q);
        var html = '';
        if (!products.length) {
          html = '<p class="ls-hh__result-none">' + esc(form.getAttribute('data-none') || 'No matches yet. Try another name, or ask us.') + '</p>';
        }
        products.forEach(function (p, idx) {
          var t = describe(p);
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          html += '<a class="ls-hh__result" role="option" id="' + box.id + '-' + idx + '" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="52" height="64">' : '<span class="ls-hh__result-ph"></span>') +
            '<span>' + (t.format ? '<span class="ls-hh__result-format">' + esc(t.format) + '</span>' : '') + '<span class="ls-hh__result-name">' + esc(t.name) + '</span>' + (t.sub ? '<span class="ls-hh__result-sub">' + esc(t.sub) + '</span>' : '') + '</span>' +
            '<span class="ls-hh__result-price">' + esc(price(p.price)) + '</span></a>';
        });
        html += '<a class="ls-hh__result-all" role="option" id="' + box.id + '-all" href="' + esc(all) + '">' + esc(form.getAttribute('data-all') || 'See all results') + ' &rarr;</a>';
        box.innerHTML = html;
        items = Array.prototype.slice.call(box.querySelectorAll('[role="option"]'));
        box.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        active = -1;
        if (live) live.textContent = products.length + ' results';
      }
      function query(q) {
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        var url = suggestUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            if (input.value.trim() === q) render(q, products);
          })
          .catch(function () {});
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function () { query(q); }, 180);
      });
      input.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(active + 1, items.length - 1)); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, 0)); }
        else if (e.key === 'Enter' && active > -1 && items[active]) { e.preventDefault(); window.location.href = items[active].href; }
        else if (e.key === 'Escape') { close(); }
      });
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) close();
      });
      form.addEventListener('submit', function (e) {
        if (!input.value.trim()) {
          e.preventDefault();
          var names = (input.getAttribute('data-names') || '').split(',');
          input.value = (names[0] || '').trim();
          input.focus();
        }
      });
    }

    function setupBar(root) {
      var bar = root.querySelector('[data-hh-bar]');
      if (!bar) return;
      var hero = root.querySelector('.ls-hh__hero');
      var fill = bar.querySelector('[data-hh-bar-fill]');
      var footer = document.querySelector('footer, .footer, .shopify-section-group-footer-group');
      var items = [];
      Array.prototype.forEach.call(bar.querySelectorAll('[data-hh-bar-link]'), function (link) {
        var href = link.getAttribute('href');
        var target = null;
        if (href && href.charAt(0) === '#') {
          try { target = document.querySelector(href); } catch (e) { target = null; }
        }
        if (target) items.push({ link: link, target: target });
        else link.parentNode.parentNode.removeChild(link.parentNode);
      });
      if (items.length < 2) return;
      bar.hidden = false;
      bar.addEventListener('click', function (event) {
        var link = event.target.closest('[data-hh-bar-link]');
        if (!link) return;
        var item = items.filter(function (it) { return it.link === link; })[0];
        if (!item) return;
        event.preventDefault();
        var top = item.target.getBoundingClientRect().top + window.pageYOffset - headerOffset() + 1;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
      var ticking = false, lastActive = null;
      function update() {
        ticking = false;
        var vh = window.innerHeight;
        bar.style.setProperty('--hh-bar-top', (headerOffset() + 8) + 'px');
        var pastHero = hero ? hero.getBoundingClientRect().bottom < vh * 0.35 : window.pageYOffset > vh;
        var nearFooter = footer ? footer.getBoundingClientRect().top < vh * 0.9 : false;
        bar.classList.toggle('is-shown', pastHero && !nearFooter);
        var line = headerOffset() + vh * 0.3;
        var active = null;
        items.forEach(function (it) { if (it.target.getBoundingClientRect().top <= line) active = it; });
        items.forEach(function (it) { it.link.classList.toggle('is-active', it === active); });
        if (active && active !== lastActive) {
          lastActive = active;
          var list = active.link.closest('.ls-hh__bar-list');
          if (list && list.scrollWidth > list.clientWidth) {
            var li = active.link.parentNode;
            list.scrollTo({ left: li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2, behavior: 'smooth' });
          }
        }
        if (fill) {
          var first = items[0].target.getBoundingClientRect().top + window.pageYOffset;
          var last = items[items.length - 1].target;
          var end = last.getBoundingClientRect().bottom + window.pageYOffset - vh;
          var pct = end > first ? (window.pageYOffset - first) / (end - first) : 0;
          fill.style.width = Math.max(0, Math.min(1, pct)) * 100 + '%';
        }
      }
      function queue() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      update();
    }

    function init(root) {
      if (!root || root.getAttribute('data-hh-ready')) return;
      root.setAttribute('data-hh-ready', '1');
      if (!reduce && !(window.Shopify && window.Shopify.designMode)) root.classList.add('is-ready');
      setupSearch(root);
      setupBar(root);
      Array.prototype.forEach.call(root.querySelectorAll('.ls-hh__cue, [data-hh-jump]'), function (link) {
        link.addEventListener('click', function (e) {
          var href = link.getAttribute('href') || '';
          if (href.charAt(0) !== '#') return;
          var t = document.querySelector(href);
          if (!t) return;
          e.preventDefault();
          window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - headerOffset() + 1, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    }
    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ls-hh]'), init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-home-picks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 
    function setupWays(root) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-hp-ways]'), function (box) {
        var rows = box.querySelectorAll('[data-hp-way]');
        var media = box.querySelectorAll('[data-hp-way-media]');
        function warm() {
          Array.prototype.forEach.call(box.querySelectorAll('[data-hp-way-media] img'), function (img) {
            img.loading = 'eager';
          });
        }
        if (document.readyState === 'complete') warm();
        else window.addEventListener('load', warm);
        function select(n) {
          Array.prototype.forEach.call(rows, function (row) {
            var on = row.getAttribute('data-hp-way') === String(n);
            row.classList.toggle('is-active', on);
            var head = row.querySelector('.ls-hp__way-head');
            if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false');
          });
          Array.prototype.forEach.call(media, function (m) {
            m.classList.toggle('is-active', m.getAttribute('data-hp-way-media') === String(n));
          });
        }
        Array.prototype.forEach.call(rows, function (row) {
          var head = row.querySelector('.ls-hp__way-head');
          var n = row.getAttribute('data-hp-way');
          head.addEventListener('click', function () { select(n); });
          head.addEventListener('mouseenter', function () {
            if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) select(n);
          });
        });
      });
    }
 
    function setupPrimers(root) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-hp-primers]'), function (box) {
        var tabs = Array.prototype.slice.call(box.querySelectorAll('[data-hp-ptab]'));
        var panels = box.querySelectorAll('[data-hp-ppanel]');
        function select(n, focus) {
          tabs.forEach(function (t) {
            var on = t.getAttribute('data-hp-ptab') === String(n);
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
            if (on && focus) t.focus();
          });
          Array.prototype.forEach.call(panels, function (p) {
            p.hidden = p.getAttribute('data-hp-ppanel') !== String(n);
          });
        }
        tabs.forEach(function (t, i) {
          t.tabIndex = i === 0 ? 0 : -1;
          t.addEventListener('click', function () { select(t.getAttribute('data-hp-ptab')); });
          t.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault();
              var next = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
              select(tabs[next].getAttribute('data-hp-ptab'), true);
            }
          });
        });
      });
    }
 
    function setupRail(root) {
      var track = root.querySelector('[data-hp-track]');
      var bar = root.querySelector('[data-hp-bar]');
      if (!track || !bar) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var share = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        bar.style.width = Math.max(share * 100, 12) + '%';
        var room = 100 / Math.max(share, 0.01) - 100;
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * room : 0) + '%)';
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
 
    function init(root) {
      if (!root || root.getAttribute('data-hp-ready')) return;
      root.setAttribute('data-hp-ready', '1');
      setupWays(root);
      setupPrimers(root);
      setupRail(root);
      if (!('IntersectionObserver' in window) || reduce || (window.Shopify && window.Shopify.designMode)) return;
      root.classList.add('is-ready');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px' });
      Array.prototype.forEach.call(root.querySelectorAll('[data-hp-reveal]'), function (el) { io.observe(el); });
    }
    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ls-hp]'), init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initInfo(root) {
      if (!root || root.getAttribute('data-ls-ready') === 'true') return;
      root.setAttribute('data-ls-ready', 'true');
      root.classList.add('ls-info--js');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var hasObserver = 'IntersectionObserver' in window;

      /* Fade cards and steps in as they enter the screen. */
      var reveal = root.querySelectorAll('[data-ls-reveal]');
      if (!reduce && hasObserver && reveal.length) {
        var revealObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.remove('is-waiting');
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        Array.prototype.forEach.call(reveal, function (el) {
          /* Slides in a swiping row are left alone so none stay invisible. */
          var row = el.closest('[data-ls-swipe]');
          if (row && row.scrollWidth - row.clientWidth > 2) return;
          el.classList.add('is-waiting');
          revealObserver.observe(el);
        });
      }

      /* Rows that swipe sideways: move the thin position bar where there is
         one, and flag rows that still have more to show. */
      Array.prototype.forEach.call(root.querySelectorAll('[data-ls-swipe]'), function (row) {
        var next = row.nextElementSibling;
        var bar = next && next.hasAttribute('data-ls-swipe-bar') ? next : null;
        var thumb = bar ? bar.firstElementChild : null;
        function update() {
          var max = row.scrollWidth - row.clientWidth;
          row.classList.toggle('has-more', max > 2 && row.scrollLeft < max - 2);
          if (!bar) return;
          if (max <= 2) {
            bar.hidden = true;
            return;
          }
          bar.hidden = false;
          var track = bar.clientWidth;
          if (!track) return;
          var size = Math.max(track * (row.clientWidth / row.scrollWidth), track * 0.25);
          var pos = (row.scrollLeft / max) * (track - size);
          thumb.style.width = size + 'px';
          thumb.style.transform = 'translateX(' + pos + 'px)';
        }
        row.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });

      /* Highlight the "On this page" link for the group being read. */
      var links = root.querySelectorAll('[data-ls-toc-link]');
      if (!hasObserver || !links.length) return;

      var targets = [];
      Array.prototype.forEach.call(links, function (link) {
        var id = (link.getAttribute('href') || '').replace('#', '');
        var target = id ? document.getElementById(id) : null;
        if (target) targets.push({ link: link, target: target });
      });
      if (!targets.length) return;

      function setCurrent(link) {
        Array.prototype.forEach.call(links, function (other) {
          if (other === link) {
            other.setAttribute('aria-current', 'true');
          } else {
            other.removeAttribute('aria-current');
          }
        });
      }

      var spy = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            targets.forEach(function (pair) {
              if (pair.target === entry.target) setCurrent(pair.link);
            });
          });
        },
        { rootMargin: '-25% 0px -65% 0px' }
      );
      targets.forEach(function (pair) {
        spy.observe(pair.target);
      });
    }

    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ls-info]'), initInfo);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-member-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function each(list, fn) {
      Array.prototype.forEach.call(list, fn);
    }

    function initMember(root) {
      if (!root || root.getAttribute('data-ls-ready') === 'true') return;
      root.setAttribute('data-ls-ready', 'true');
      root.classList.add('ls-member--js');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var words = {
        upto: root.getAttribute('data-upto') || '',
        item: root.getAttribute('data-item') || 'item',
        items: root.getAttribute('data-items') || 'items',
        save: root.getAttribute('data-text-save') || '',
        none: root.getAttribute('data-text-none') || '',
        next: root.getAttribute('data-text-next') || '',
        top: root.getAttribute('data-text-top') || ''
      };
      var chips = root.querySelectorAll('[data-lm-chip]');
      var panels = root.querySelectorAll('[data-lm-panel]');

      function readTiers(panel) {
        var list = [];
        each(panel.querySelectorAll('[data-lm-tier]'), function (el) {
          list.push({ el: el, min: Number(el.getAttribute('data-min')), pct: Number(el.getAttribute('data-pct')) });
        });
        return list;
      }

      /* The counter under each ladder. */
      each(panels, function (panel) {
        var counter = panel.querySelector('[data-lm-counter]');
        if (!counter) return;
        var qtyEl = counter.querySelector('[data-lm-qty]');
        var saveEl = counter.querySelector('[data-lm-save]');
        var nextEl = counter.querySelector('[data-lm-next]');
        var qty = null;

        function render() {
          var tiers = readTiers(panel);
          if (!tiers.length) {
            counter.hidden = true;
            return;
          }
          counter.hidden = false;
          if (qty === null) qty = tiers[0].min;
          var saved = 0;
          var next = null;
          tiers.forEach(function (tier) {
            var reached = qty >= tier.min;
            tier.el.classList.toggle('is-reached', reached);
            if (reached) saved = tier.pct;
            else if (!next) next = tier;
          });
          qtyEl.textContent = qty + ' ' + (qty === 1 ? words.item : words.items);
          saveEl.textContent = saved ? words.save.replace('{pct}', saved) : words.none;
          nextEl.textContent = next
            ? words.next.replace('{n}', next.min - qty).replace('{pct}', next.pct)
            : words.top;
        }
        function step(change) {
          var tiers = readTiers(panel);
          if (!tiers.length) return;
          var max = tiers[tiers.length - 1].min + 2;
          qty = Math.min(max, Math.max(1, (qty === null ? tiers[0].min : qty) + change));
          render();
        }
        counter.querySelector('[data-lm-less]').addEventListener('click', function () {
          step(-1);
        });
        counter.querySelector('[data-lm-more]').addEventListener('click', function () {
          step(1);
        });
        panel.lmReset = function () {
          qty = null;
          render();
        };
        render();
      });

      /* Choosing a bundle. */
      function select(index) {
        var wanted = String(index);
        each(chips, function (chip) {
          var on = chip.getAttribute('data-lm-chip') === wanted;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        each(panels, function (panel) {
          var on = panel.getAttribute('data-lm-panel') === wanted;
          panel.classList.toggle('is-off', !on);
          if (on) panel.removeAttribute('aria-hidden');
          else panel.setAttribute('aria-hidden', 'true');
          if (on) root.setAttribute('data-lm-stage', panel.getAttribute('data-lm-stage') || 'idle');
        });
      }
      each(chips, function (chip) {
        chip.addEventListener('click', function () {
          select(chip.getAttribute('data-lm-chip'));
        });
      });
      root.lmSelect = select;
      if (panels.length) select(0);

      /* The chip row swipes on small screens. */
      each(root.querySelectorAll('[data-lm-swipe]'), function (row) {
        function update() {
          var max = row.scrollWidth - row.clientWidth;
          row.classList.toggle('has-more', max > 2 && row.scrollLeft < max - 2);
        }
        row.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });

      /* Take the real tiers from the Bundler app when it is on the page, so
         the ladder always matches what customers are charged. A bundle's
         code is its Bundler id written in base 36. */
      function applyLive() {
        if (!window.bndlr || typeof window.bndlr.getBundles !== 'function') return false;
        var bundles;
        try {
          bundles = window.bndlr.getBundles();
        } catch (error) {
          return true;
        }
        if (!bundles || !bundles.length) return false;

        each(panels, function (panel) {
          var code = (panel.getAttribute('data-lm-code') || '').toLowerCase();
          var ladder = panel.querySelector('[data-lm-ladder]');
          if (!code || !ladder || !/^[0-9a-z]+$/.test(code)) return;
          var id = parseInt(code, 36);
          var match = null;
          each(bundles, function (bundle) {
            if (Number(bundle.id) === id) match = bundle;
          });
          if (!match || !match.volume_discounts || !match.volume_discounts.length) return;

          var tiers = [];
          each(match.volume_discounts, function (row) {
            var min = Number(row.min_items);
            var pct = Number(row.discount_value);
            if (row.discount_type === 'percentage' && min > 0 && pct > 0) tiers.push({ min: min, pct: pct });
          });
          if (!tiers.length) return;
          tiers.sort(function (a, b) {
            return a.min - b.min;
          });

          while (ladder.firstChild) ladder.removeChild(ladder.firstChild);
          tiers.forEach(function (tier, position) {
            var item = document.createElement('li');
            var pct = document.createElement('span');
            var label = document.createElement('span');
            item.className = 'ls-member__tier';
            item.setAttribute('data-lm-tier', '');
            item.setAttribute('data-min', tier.min);
            item.setAttribute('data-pct', tier.pct);
            pct.className = 'ls-member__tier-pct';
            pct.textContent = tier.pct + '%';
            label.className = 'ls-member__tier-label';
            label.textContent = tier.min + (position === tiers.length - 1 ? '+' : '') + ' ' + words.items;
            item.appendChild(pct);
            item.appendChild(label);
            ladder.appendChild(item);
          });

          var chip = root.querySelector('[data-lm-chip="' + panel.getAttribute('data-lm-panel') + '"] [data-lm-chip-note]');
          if (chip) chip.textContent = (words.upto + ' ' + tiers[tiers.length - 1].pct + '%').trim();
          if (panel.lmReset) panel.lmReset();
        });

        var top = 0;
        each(root.querySelectorAll('[data-lm-panel] [data-lm-tier]'), function (el) {
          top = Math.max(top, Number(el.getAttribute('data-pct')) || 0);
        });
        if (top) {
          each(root.querySelectorAll('[data-lm-top]'), function (el) {
            el.textContent = top + '%';
          });
        }
        return true;
      }
      if (root.getAttribute('data-live') === 'true') {
        var tries = 0;
        var timer = window.setInterval(function () {
          tries += 1;
          if (applyLive() || tries > 25) window.clearInterval(timer);
        }, 400);
      }

      /* The assistant bar. It watches the Bundler app's builder and says
         what to do next: add a product, keep going, or press the app's
         Add Bundle to Cart. Class names are the app's own. If the app's
         parts cannot be found, the bar keeps its general instruction. */
      var say = {
        idle: root.getAttribute('data-say-idle') || '',
        start: root.getAttribute('data-say-start') || '',
        building: root.getAttribute('data-say-building') || '',
        ready: root.getAttribute('data-say-ready') || '',
        final: root.getAttribute('data-say-final') || ''
      };
      var tag = {
        idle: root.getAttribute('data-tag-idle') || '',
        start: root.getAttribute('data-tag-start') || '',
        building: root.getAttribute('data-tag-building') || '',
        ready: root.getAttribute('data-tag-ready') || ''
      };
      var bars = root.querySelectorAll('[data-lm-status]');

      function shown(el) {
        return !!el && !el.closest('.bndlr-hidden') && el.getClientRects().length > 0;
      }
      function clean(el) {
        return shown(el) ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
      }

      each(panels, function (panel) {
        var bar = panel.querySelector('[data-lm-status]');
        var widget = panel.querySelector('.ls-member__widget');
        if (!bar || !widget) return;
        var labelEl = bar.querySelector('[data-lm-status-label]');
        var textEl = bar.querySelector('[data-lm-status-text]');
        var go = bar.querySelector('[data-lm-status-go]');
        var most = null;
        var last = '';
        var queued = false;

        if (say.final) {
          panel.style.setProperty('--lm-final-hint', '"' + say.final.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"');
        }

        function read() {
          var cart = widget.querySelector('.bndlr-add-bundle-to-cart');
          if (!cart) return { stage: 'idle', note: '' };
          if (shown(cart)) {
            return { stage: 'ready', note: clean(widget.querySelector('.bndlr-tiered-mnm-instructions-text')) };
          }
          var need = clean(widget.querySelector('.bndlr-mnm-instructions-text'));
          var found = /(\d+)/.exec(need);
          var left = found ? Number(found[1]) : null;
          if (left !== null && (most === null || left > most)) most = left;
          var picked = widget.querySelector('.bndlr-mnm-selected-products');
          var started = (shown(picked) && picked.children.length > 0) || (left !== null && most !== null && left < most);
          return { stage: started ? 'building' : 'start', note: started ? need : '' };
        }

        function render() {
          queued = false;
          var now = read();
          var text = say[now.stage] || say.idle;
          if (now.note) text = now.stage === 'ready' ? text + ' ' + now.note : now.note + ' ' + text;
          var key = now.stage + '|' + text;
          if (key === last) return;
          var first = last === '';
          last = key;
          panel.setAttribute('data-lm-stage', now.stage);
          if (!panel.classList.contains('is-off')) root.setAttribute('data-lm-stage', now.stage);
          if (labelEl) labelEl.textContent = tag[now.stage] || tag.idle;
          if (textEl) textEl.textContent = text;
          if (go) go.hidden = now.stage !== 'ready';
          if (!first && !reduce) {
            bar.classList.remove('is-flash');
            void bar.offsetWidth;
            bar.classList.add('is-flash');
          }
        }
        function queue() {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(render);
        }

        if (go) {
          go.addEventListener('click', function () {
            var cart = widget.querySelector('.bndlr-add-bundle-to-cart');
            if (!cart) return;
            cart.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            cart.classList.remove('ls-member-point');
            void cart.offsetWidth;
            cart.classList.add('ls-member-point');
          });
        }

        if ('MutationObserver' in window) {
          new MutationObserver(queue).observe(widget, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden']
          });
        }
        render();
      });

      /* Keep the bar just under the site header when the header is fixed
         to the top of the screen. */
      if (bars.length) {
        var stickQueued = false;
        var setStick = function () {
          stickQueued = false;
          var top = 0;
          each(document.querySelectorAll('.section-header, sticky-header, .shopify-section-group-header-group'), function (el) {
            var position = window.getComputedStyle(el).position;
            if (position !== 'sticky' && position !== 'fixed') return;
            var box = el.getBoundingClientRect();
            if (box.top <= 1 && box.bottom > 0 && box.bottom < window.innerHeight / 2) {
              top = Math.max(top, Math.round(box.bottom));
            }
          });
          root.style.setProperty('--lm-stick', top + 'px');
        };
        var queueStick = function () {
          if (stickQueued) return;
          stickQueued = true;
          window.requestAnimationFrame(setStick);
        };
        window.addEventListener('scroll', queueStick, { passive: true });
        window.addEventListener('resize', queueStick);
        setStick();
      }

      /* Fade the steps and member tiers in as they enter the screen. */
      var reveal = root.querySelectorAll('[data-lm-reveal]');
      if (!reduce && 'IntersectionObserver' in window && reveal.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.remove('is-waiting');
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        each(reveal, function (el) {
          el.classList.add('is-waiting');
          observer.observe(el);
        });
      }
    }

    function initAll(scope) {
      each((scope || document).querySelectorAll('[data-ls-member]'), initMember);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    /* In the theme editor: set up again after a change, ask the app to
       fill the builders again, and bring a chosen bundle forward. */
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
      if (!event.target.querySelector || !event.target.querySelector('[data-ls-member]')) return;
      if (window.bndlr && typeof window.bndlr.refresh === 'function') {
        try {
          window.bndlr.refresh();
        } catch (error) {}
      }
    });
    document.addEventListener('shopify:block:select', function (event) {
      var el = event.target;
      if (!el || !el.closest || !el.hasAttribute('data-lm-panel')) return;
      var root = el.closest('[data-ls-member]');
      if (root && root.lmSelect) root.lmSelect(el.getAttribute('data-lm-panel'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-member-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function each(list, fn) {
      Array.prototype.forEach.call(list, fn);
    }

    function initCollection(root) {
      if (!root || root.getAttribute('data-ls-ready') === 'true') return;
      root.setAttribute('data-ls-ready', 'true');
      root.classList.add('ls-mcol--js');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var items = root.querySelectorAll('[data-lc-item]');
      var chips = root.querySelectorAll('[data-lc-filter]');
      var count = root.querySelector('[data-lc-count]');
      var countWord = root.querySelector('[data-lc-count-word]');
      var total = count ? count.textContent : '';

      /* Filter by product type. */
      function filter(type) {
        var shown = 0;
        each(items, function (item) {
          var on = type === 'all' || item.getAttribute('data-type') === type;
          item.hidden = !on;
          if (on) {
            shown += 1;
            item.classList.remove('is-waiting');
          }
        });
        each(chips, function (chip) {
          var active = chip.getAttribute('data-lc-filter') === type;
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (count) count.textContent = type === 'all' ? total : String(shown);
        if (count && countWord) {
          countWord.textContent = countWord.getAttribute(Number(count.textContent) === 1 ? 'data-one' : 'data-many');
        }
      }
      each(chips, function (chip) {
        chip.addEventListener('click', function () {
          filter(chip.getAttribute('data-lc-filter'));
        });
      });

      /* The chip row swipes on small screens. */
      each(root.querySelectorAll('[data-lc-swipe]'), function (row) {
        function update() {
          var max = row.scrollWidth - row.clientWidth;
          row.classList.toggle('has-more', max > 2 && row.scrollLeft < max - 2);
        }
        row.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });

      /* Add to cart, handing the result to the theme's cart drawer. */
      each(root.querySelectorAll('[data-lc-atc]'), function (button) {
        button.addEventListener('click', function () {
          if (button.disabled || button.classList.contains('is-loading')) return;
          var variantId = button.getAttribute('data-variant-id');
          if (!variantId) return;

          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          var data = new FormData();
          data.append('id', variantId);
          data.append('quantity', '1');
          if (cart && typeof cart.getSectionsToRender === 'function') {
            data.append(
              'sections',
              cart.getSectionsToRender().map(function (part) {
                return part.id;
              })
            );
            data.append('sections_url', window.location.pathname);
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          }

          var label = button.textContent;
          button.classList.add('is-loading');
          fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: data
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (result) {
              if (result.status) return;
              if (cart && typeof cart.renderContents === 'function') {
                if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                cart.renderContents(result);
              } else {
                window.location.href = (window.routes && window.routes.cart_url) || '/cart';
                return;
              }
              var added = root.getAttribute('data-added');
              if (added) {
                button.textContent = added;
                button.classList.add('is-added');
                window.setTimeout(function () {
                  button.textContent = label;
                  button.classList.remove('is-added');
                }, 1800);
              }
            })
            .catch(function () {})
            .then(function () {
              button.classList.remove('is-loading');
            });
        });
      });

      /* Review stars are drawn by Judge.me once the page is ready. */
      if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') window.jdgm.customizeBadges();

      /* Fade the products in as they enter the screen. */
      var reveal = root.querySelectorAll('[data-lc-reveal]');
      if (!reduce && 'IntersectionObserver' in window && reveal.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.remove('is-waiting');
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -6% 0px' }
        );
        each(reveal, function (el) {
          el.classList.add('is-waiting');
          observer.observe(el);
        });
      }
    }

    function initAll(scope) {
      each((scope || document).querySelectorAll('[data-ls-mcol]'), initCollection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-members-club"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function each(list, fn) {
      Array.prototype.forEach.call(list, fn);
    }

    function initClub(root) {
      if (!root || root.getAttribute('data-ls-ready') === 'true') return;
      root.setAttribute('data-ls-ready', 'true');
      root.classList.add('ls-club--js');

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var design = root.getAttribute('data-design') === 'true';
      var showPerk = null;

      /* The perks. Tabs that step through on their own until someone
         picks one. */
      var perks = root.querySelector('[data-lk-perks]');
      if (perks) {
        var tabs = perks.querySelectorAll('[data-lk-tab]');
        var panels = perks.querySelectorAll('[data-lk-panel]');
        var row = perks.querySelector('[data-lk-swipe]');
        var seconds = Number(perks.getAttribute('data-lk-autoplay')) || 0;
        var playing = seconds > 0 && !reduce && !design && tabs.length > 1;
        var current = 0;

        function stop() {
          if (!playing) return;
          playing = false;
          perks.classList.remove('is-playing');
        }

        showPerk = function (index, fromUser) {
          if (fromUser) stop();
          current = index;
          each(tabs, function (tab, i) {
            var on = i === index;
            tab.classList.toggle('is-active', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.setAttribute('tabindex', on ? '0' : '-1');
          });
          each(panels, function (panel, i) {
            panel.classList.toggle('is-active', i === index);
          });
          if (row && row.scrollWidth > row.clientWidth + 2) {
            var left = Math.max(0, tabs[index].offsetLeft - 15);
            if (typeof row.scrollTo === 'function') {
              row.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
            } else {
              row.scrollLeft = left;
            }
          }
        };

        each(tabs, function (tab, i) {
          tab.addEventListener('click', function () {
            showPerk(i, true);
          });
          tab.addEventListener('keydown', function (event) {
            var next = -1;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next < 0) return;
            event.preventDefault();
            showPerk(next, true);
            tabs[next].focus();
          });
          var bar = tab.querySelector('[data-lk-progress]');
          if (bar) {
            bar.addEventListener('animationend', function () {
              if (playing && i === current) showPerk((i + 1) % tabs.length, false);
            });
          }
        });

        if (playing) {
          perks.style.setProperty('--lk-dur', seconds + 's');
          perks.classList.add('is-playing');
          var panelsBox = perks.querySelector('.ls-club__panels');
          if (panelsBox && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
            panelsBox.addEventListener('mouseenter', function () {
              perks.classList.add('is-paused');
            });
            panelsBox.addEventListener('mouseleave', function () {
              perks.classList.remove('is-paused');
            });
          }
          if (panelsBox) {
            panelsBox.addEventListener('focusin', stop);
            panelsBox.addEventListener('touchstart', stop, { passive: true });
          }
          if ('IntersectionObserver' in window) {
            perks.classList.add('is-away');
            new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  perks.classList.toggle('is-away', !entry.isIntersecting);
                });
              },
              { threshold: 0.3 }
            ).observe(perks.querySelector('.ls-club__explorer') || perks);
          }
        }
      }

      /* The tab row swipes on small screens. */
      each(root.querySelectorAll('[data-lk-swipe]'), function (swipe) {
        function update() {
          var max = swipe.scrollWidth - swipe.clientWidth;
          swipe.classList.toggle('has-more', max > 2 && swipe.scrollLeft < max - 2);
        }
        swipe.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });

      /* Questions. One open at a time. */
      var questions = root.querySelectorAll('[data-lk-q]');
      each(questions, function (question) {
        question.addEventListener('toggle', function () {
          if (!question.open) return;
          each(questions, function (other) {
            if (other !== question) other.open = false;
          });
        });
      });

      /* In the theme editor, show the block that was picked. */
      root.addEventListener('shopify:block:select', function (event) {
        var target = event.target;
        if (!target || !target.hasAttribute) return;
        if (target.hasAttribute('data-lk-tab') && showPerk) {
          showPerk(Array.prototype.indexOf.call(target.parentNode.children, target), true);
        }
        if (target.hasAttribute('data-lk-q')) target.open = true;
      });

      /* Fade parts in as they enter the screen. */
      var reveal = root.querySelectorAll('[data-lk-reveal]');
      if (!reduce && !design && 'IntersectionObserver' in window && reveal.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.remove('is-waiting');
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -6% 0px' }
        );
        each(reveal, function (el) {
          el.classList.add('is-waiting');
          observer.observe(el);
        });
      }
    }

    function initAll(scope) {
      each((scope || document).querySelectorAll('[data-ls-club]'), initClub);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-news"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function each(list, fn) {
      Array.prototype.forEach.call(list, fn);
    }

    function initNews(root) {
      if (!root || root.getAttribute('data-ls-ready') === 'true') return;
      root.setAttribute('data-ls-ready', 'true');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var design = root.getAttribute('data-design') === 'true';

      /* The next drop counts down, and steps aside once it has passed. */
      each(root.querySelectorAll('[data-ln-drop]'), function (tile) {
        var raw = tile.getAttribute('data-ln-drop') || '';
        var when = Date.parse(raw.replace(/([+-]\d{2})(\d{2})$/, '$1:$2'));
        if (isNaN(when)) {
          tile.hidden = true;
          return;
        }
        var days = tile.querySelector('[data-ln-days]');
        var hours = tile.querySelector('[data-ln-hours]');
        var mins = tile.querySelector('[data-ln-mins]');
        function pad(n) {
          return n < 10 ? '0' + n : String(n);
        }
        function tick() {
          var left = when - Date.now();
          if (left <= 0) {
            tile.hidden = true;
            var list = tile.parentNode;
            if (list) list.style.setProperty('--ln-tiles', Math.max(1, list.querySelectorAll('.ls-news__tile:not([hidden])').length));
            return false;
          }
          var m = Math.floor(left / 60000);
          if (days) days.textContent = String(Math.floor(m / 1440));
          if (hours) hours.textContent = pad(Math.floor((m % 1440) / 60));
          if (mins) mins.textContent = pad(m % 60);
          return true;
        }
        if (tick()) {
          var timer = window.setInterval(function () {
            if (!tick()) window.clearInterval(timer);
          }, 20000);
        }
      });

      /* Fade updates in as they enter the screen. */
      var reveal = root.querySelectorAll('[data-ln-reveal]');
      if (!reduce && !design && 'IntersectionObserver' in window && reveal.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.remove('is-waiting');
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -6% 0px' }
        );
        each(reveal, function (el) {
          el.classList.add('is-waiting');
          observer.observe(el);
        });
      }
    }

    function initAll(scope) {
      each((scope || document).querySelectorAll('[data-ls-news]'), initNews);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lescent-scent-drop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.getAttribute('data-drop-ready')) return;
      root.setAttribute('data-drop-ready', '1');
      var items = root.querySelectorAll('[data-drop-reveal]');
      if (!('IntersectionObserver' in window)) return;
      root.classList.add('js-ready');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      Array.prototype.forEach.call(items, function (el) { io.observe(el); });
    }
    function boot() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ls-drop]'), init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-ls-drop]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
